import { useLocation, Link } from '@tanstack/react-router'
import { useEffect } from 'react'
import styles from './NotFound.module.css'

const NotFound = () => {
  const location = useLocation()

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname)
  }, [location.pathname])

  return (
    <div className={styles.container}>
      <div className={styles.code}>404</div>
      <h1 className={styles.heading}>Page not found</h1>
      <p className={styles.description}>The page you're looking for doesn't exist or has been moved.</p>
      <Link to="/" preload="intent" className={styles.link}>
        Back to home
      </Link>
    </div>
  )
}

export default NotFound
